import _slicedToArray from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _taggedTemplateLiteral from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: inline-block;\n  flex-shrink: 0;\n  position: relative;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { __rest } from "tslib";
import React, { useRef, useState } from 'react';
import styled from 'styled-components';
import { WithOutsideClick } from '@scp/ui-shared/components/wrappers';
import { IconButton } from '@scp/ui-shared/components/buttons/IconButton';
import { getE2eLabel } from '@scp/ui-shared/components/utils';
import { Popover } from './Popover';
var E2E_MENU_BUTTON = 'menu-button';
var Wrapper = styled(WithOutsideClick)(_templateObject());
/**
 * A popover with a `<IconButton />` trigger to toggle it.
 * Use it, when the popover should not be controlled from the outside,
 * since it uses internal state for expanded/collapsed state.
 *
 * If you need more control, use raw `<Popover />`.
 *
 * @example ./__docs__/IconPopover.md
 */

export function IconPopover(_a) {
  var buttonTitle = _a.buttonTitle,
      icon = _a.icon,
      _a$onToggle = _a.onToggle,
      onToggle = _a$onToggle === void 0 ? function () {} : _a$onToggle,
      _a$open = _a.open,
      open = _a$open === void 0 ? false : _a$open,
      _a$closesOnClick = _a.closesOnClick,
      closesOnClick = _a$closesOnClick === void 0 ? false : _a$closesOnClick,
      concise = _a.concise,
      otherProps = __rest(_a, ["buttonTitle", "icon", "onToggle", "open", "closesOnClick", "concise"]);

  var iconRef = useRef();

  var _useState = useState(open),
      _useState2 = _slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      setOpen = _useState2[1];

  var togglePopover = function togglePopover() {
    onToggle(!isOpen);
    setOpen(!isOpen);
  };

  var closePopover = function closePopover() {
    onToggle(false);
    setOpen(false);
  };

  var handleClick = function handleClick() {
    closePopover();
    if (iconRef.current) iconRef.current.focus();
  };

  var handleBtnKeyDown = function handleBtnKeyDown(e) {
    if (!isOpen && (e.key === 'ArrowDown' || e.key === 'ArrowUp')) {
      togglePopover();
    }
  }; // Do not call `onBlur` when clicking with mouse. See `<Popover />` for more details.


  var handleBtnMouseDown = function handleBtnMouseDown(e) {
    return e.preventDefault();
  };

  return React.createElement(Wrapper, {
    onClickOutside: closePopover
  }, React.createElement(IconButton, {
    title: buttonTitle,
    onClick: togglePopover,
    onKeyDown: handleBtnKeyDown,
    "aria-haspopup": true,
    "aria-expanded": isOpen,
    ref: iconRef,
    onMouseDown: handleBtnMouseDown,
    concise: concise,
    "data-e2e": getE2eLabel(E2E_MENU_BUTTON)
  }, icon), React.createElement(Popover, Object.assign({
    onClose: closePopover
  }, otherProps, {
    onClick: closesOnClick ? handleClick : undefined,
    open: isOpen
  })));
}